
/**
 * Hard-coded map that connects show IDs to their thumbnails stored in the news CDN.
 * We can all think of a dozen cleaner implementations, but this is the fastest for a time-sensitive
 * ticket.
 */
export const SHOW_DETAILS_MAP = {
  SH000028660000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415586/New Image - Meet The Press Daily_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.nbc.com/meet-the-press',
  },
  SH000213900000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415580/New Image -  Morning Joe_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/morning-joe',
  },
  SH010835610000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415592/New Image - The Rachel Maddow Show_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/rachel-maddow-show',
  },
  SH011659250000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415575/New Image - Andrea Mitchell Reports_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/andrea-mitchell',
  },
  SH013300400000: {
    thumbnail: 'https://media3.s-nbcnews.com/i/newscms/2020_39/3415081/the_last_word_with_lawrence_odonnell_1fd223715820af56176bfe0522dac258.png',
    frontURL: 'https://www.msnbc.com/the-last-word',
  },
  SH014695780000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415587/New Image - PoliticsNation with Al Sharpton_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/politicsnation',
  },
  SH014757030000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415596/New Image - Weekends with Alex Witt_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/weekends-with-alex',
  },
  SH017174310000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415574/New Image - All In with Chris Hayes_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/all',
  },
  SH022745780000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415586/New Image - Meet The Press Daily_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/mtp-daily',
  },
  // AM Joy
  SH024311730000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415593/New Image - The Reidout_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.nbc.com/am-joy',
  },
  SH025041300000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415589/New Image - The 11th Hour with Brian Williams_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/11th-hour-with-Brian-Williams',
  },
  SH025291110000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415584/New Image - MSNBC Live with Stephanie Ruhle_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/stephanie-ruhle',
  },
  SH025291140000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415581/New Image - MSNBC Live with Craig Melvin_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'Retrieving data. Wait a few seconds and try to cut or copy again.',
  },
  SH025291200000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415582/New Image - MSNBC Live with Hallie Jackson_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/msnbc-live-hallie-jackson',
  },
  SH026894040000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415819/New Image - Deadline White House_b5e70d76ba890568ba34aa60362fffd5.png',
    frontURL: 'Retrieving data. Wait a few seconds and try to cut or copy again.',
  },
  SH027429830000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415583/New Image - MSNBC Live with Katy Tur_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/msnbc-live-katy-tur',
  },
  SH027437400000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415590/New Image - The Beat with Ari Melber_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/the-beat-with-ari-melber',
  },
  SH028777710000: {
    // MSNBC Live with with Yasmin Vossoughian
    thumbnail: 'https://media3.s-nbcnews.com/i/newscms/2020_51/3435620/168x168_yasmin_vossoughian_4c59c3b96e7521464bf2b6baecbb35b7.png',
    frontURL: 'https://www.msnbc.com/yasmin-vossoughian',
  },
  SH034467190000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415595/New Image - MSNBC Live with Ali Velshi_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/velshi',
  },
  SH035600410000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_40/3415593/New Image - The Reidout_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/reidout',
  },
  SH036147300000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_40/3415579/New Image - Kasie DC_55dc9105a08f4b55844eaf37052a21d9.png',
    frontURL: 'https://www.msnbc.com/way-too-early-kasie-hunt',
  },
  // The Week with Joshua Johnson
  SH036137750000: {
    thumbnail: 'https://media2.s-nbcnews.com/i/newscms/2020_51/3435614/168x168_joshua_johnson_4c59c3b96e7521464bf2b6baecbb35b7.png',
    frontURL: 'https://www.msnbc.com/the-week-joshua-johnson',
  },
  // The Cross Connection with Tiffany Cross
  SH037118540000: {
    thumbnail: 'https://media3.s-nbcnews.com/i/newscms/2020_51/3435615/168x168_tiffany_cross_4c59c3b96e7521464bf2b6baecbb35b7.png',
    frontURL: 'https://www.msnbc.com/cross-connection',
  },
  // The Sunday Show with Jonathan Capehart
  SH037118500000: {
    thumbnail: 'https://media1.s-nbcnews.com/i/newscms/2020_51/3435613/168x168_jonathan_capehart_4c59c3b96e7521464bf2b6baecbb35b7.png',
    frontURL: 'https://www.msnbc.com/sunday-show',
  },
  // American Voices with Alicia Menendez
  SH036137810000: {
    thumbnail: 'https://media4.s-nbcnews.com/i/newscms/2020_51/3435612/168x168_alicia_menendez_4c59c3b96e7521464bf2b6baecbb35b7.png',
    frontURL: 'https://www.msnbc.com/american-voices-alicia-menendez',
  },
};

export const DEFAULT_THUMBNAIL = 'https://media2.s-nbcnews.com/i/newscms/2020_40/3415585/New Image - MSNBC Live_55dc9105a08f4b55844eaf37052a21d9.png';
